import { Backdrop, Box } from '@mui/material';
import { ForwardedRef, forwardRef } from 'react';

import { Loader, LoaderWheel } from './HBLoadingGear.styles';

type HBLoadingCogsProps = {
  isOpen: boolean;
};

export const HBLoadingGear = forwardRef(
  <T extends HTMLDivElement>(props: HBLoadingCogsProps, ref: ForwardedRef<T>) => {
    const { isOpen, ...rest } = props;
    return (
      <Backdrop
        {...rest}
        ref={ref}
        open={isOpen}
        sx={{
          zIndex: 1500,
          backdropFilter: 'blur(3px)',
          backgroundColor: ' rgba(0, 0, 0, -0.5)',
        }}
      >
        <Box>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexDirection: 'column',
            }}
          >
            <Box>
              <Box
                alt="logo"
                component="img"
                height={104}
                src="/assets/svg/TapsiShopDark.svg"
                sx={{ objectFit: 'contain' }}
              />
            </Box>
            <Box>
              <Loader>
                <LoaderWheel />
                <LoaderWheel />
                <LoaderWheel />
                <LoaderWheel />
                <LoaderWheel />
                <LoaderWheel />
                <LoaderWheel />
                <LoaderWheel />
              </Loader>
            </Box>
          </Box>
        </Box>
      </Backdrop>
    );
  },
);

HBLoadingGear.displayName = 'HBLoadingGear';
